/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Export_TitleInputs */

const en_summary_export_title = /** @type {(inputs: Summary_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export summary`)
};

const es_summary_export_title = /** @type {(inputs: Summary_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar resumen`)
};

/**
* | output |
* | --- |
* | "Export summary" |
*
* @param {Summary_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const summary_export_title = /** @type {((inputs?: Summary_Export_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Export_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_summary_export_title(inputs)
	return en_summary_export_title(inputs)
});